import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {App} from '@app/App';
import reportWebVitals from './reportWebVitals';
import {store} from '@store';
import {Provider} from 'react-redux';
import {ThemeProvider} from 'styled-components';
import {theme} from '@styles/theme';
import {setStore} from '@api/apiClient';
import {SkeletonTheme} from "react-loading-skeleton";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// устанавливаем store для apiClient, чтобы избежать зацикливания при обращение к стору напрямую из apiClient и middleware
setStore(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SkeletonTheme baseColor={theme.colors.basic06} borderRadius={theme.roundedSmall}>
          <App />
        </SkeletonTheme>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
